<p-dialog
  class="filters-modal"
  [header]="'Wallets para depositar'"
  [modal]="true"
  [style]="{ width: '850px' }"
  closeOnEscape="false"
  (visibleChange)="exitView()"
  [(visible)]="showWallets"
>
  <div class="wallets-container">
    <!-- CRYPTO -->
    <div class="wallet-picker" *ngIf="currencyType === 'crypto'">
      <div class="select-network-title">Selecciona un token:</div>
      <div class="networks">
        <div
          class="network"
          *ngFor="let token of walletList"
          [class.active]="selectedToken == token"
          (click)="selectToken(token)"
        >
          <img [src]="'img/currencies/' + token.symbol + '.png'" alt="" />

          <div class="token-symbol">
            {{ token.symbol }}
          </div>

          <div class="token-row">
            <div class="token-item">
              <div class="token-subtitle">Token:</div>
              <div class="token-value">
                {{ token.symbol }}
              </div>
            </div>

            <div class="token-item">
              <div class="token-subtitle">Network:</div>
              <div class="token-value">{{ token.blockchain }}</div>
            </div>
          </div>

          <div class="token-item" (click)="copy(token.address, $event)">
            <div class="token-subtitle">Address:</div>
            <div class="token-address">
              {{ token.address }} <i class="pi pi-clone"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FIAT -->
    <div class="wallet-picker" *ngIf="currencyType === 'fiat'">
      <div class="select-network-title">
        Realiza una transferencia bancaria a los siguientes datos
      </div>
      <div class="networks">
        <div
          class="network fiat"
          [class.active]="selectedToken == token"
          (click)="selectToken(token)"
        >
          <img [src]="'img/banks/' + token.wallet + '.png'" alt="" />
          <div class="token-symbol">
            {{ token.description }}
          </div>
          <div class="token-row">
            <div class="token-item">
              <div class="token-subtitle">Titular:</div>
              <div class="token-value">
                {{ token.holder }}
              </div>
            </div>
            <div class="token-item">
              <div class="token-subtitle">Cedula/RIF:</div>
              <div class="token-value">{{ token.id }}</div>
            </div>
          </div>
          <div
            class="token-item"
            (click)="utilsService.copyToClipboard(token.address)"
          >
            <div class="token-subtitle">Cuenta bancaria:</div>
            <div class="token-address">
              {{ token.account }} <i class="pi pi-clone"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="disclaimer" *ngIf="currencyType === 'crypto'">
      <div class="title">
        <i class="pi pi-exclamation-circle"></i>
        Información Importante
      </div>
      Recargue el monto que desea agregar
      <b>transferiéndolo al address seleccionado</b> y utilizando el
      <b>token correspondiente a la red elegida</b>. Espere a que la transacción
      sea confirmada en la red para que el saldo se refleje correctamente.
      <span *ngIf="type === 'virtual_card'">
        <br /><br />
        Es necesario que declares tu depósito en nuestro sistema para que
        nuestro equipo pueda validar tu pago y procesar el saldo de manera
        exitosa.
      </span>
      <br /><br />
      El tiempo de acreditación puede variar según el método y la red utilizada.
    </div>
  </div>
  <div class="buttons-container">
    <p-button label="Volver" severity="secondary" (click)="exitView()" />
    <p-button
      label="Declarar depósito"
      severity="secondary"
      (click)="toggleShowDeclarePayment()"
      *ngIf="selectedToken && type !== 'virtual_card'"
    />
  </div>
</p-dialog>
